import { ReactNode } from 'react';
import DSBox from '../../../../../design-system/DSBox';
import { COLLECTION_COVER_BORDER_RADIUS as BORDER_RADIUS } from '../../../../../design-system/Collection';
import { DSTypography } from '../../../../../design-system/Typography';

export type AssetBoxProps = {
  label: string;
  imageUrl: string;
  alt?: string;
};

const AssetBoxFrame = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <DSBox
    sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    }}
  >
    <DSTypography variant="body1">{label}</DSTypography>

    <DSBox
      sx={{
        aspectRatio: '1',
        borderRadius: BORDER_RADIUS,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </DSBox>
  </DSBox>
);

/** The collection cover, shaped the way the Shopify product page shows it. */
export const CoverImageAssetBox = ({ label, imageUrl, alt }: AssetBoxProps) => (
  <AssetBoxFrame label={label}>
    <img
      src={imageUrl}
      alt={alt || label}
      style={{
        borderRadius: BORDER_RADIUS,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
    />
  </AssetBoxFrame>
);

/** An uploaded asset at its natural shape, so the whole file stays visible. */
const AssetBox = ({ label, imageUrl, alt }: AssetBoxProps) => (
  <AssetBoxFrame label={label}>
    <img
      src={imageUrl}
      alt={alt || label}
      style={{
        borderRadius: BORDER_RADIUS,
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
      }}
    />
  </AssetBoxFrame>
);

export default AssetBox;
